/**
 * Hold the page still while something is layered over it (BON-534).
 *
 * NOT unit-tested: the hook keeps its count in module state and writes to
 * `document.body`, and this runner shares both across test files while not
 * flushing effects deterministically — a test of it measured its own
 * scheduling rather than the hook, and failed or passed depending on which
 * file ran first. Verified in the browser instead.
 *
 * Counted rather than each caller remembering the previous value. Two overlays
 * whose lifetimes overlap — one closing as another opens, which is exactly what
 * a re-render or a quick re-open produces — would otherwise have the second
 * capture "hidden" as the value to restore, or the first restore "" while the
 * second still needs the lock. The count makes the order irrelevant: the lock
 * goes on at one and comes off at zero.
 */
import { useEffect } from 'react';

let held = 0;
let restoreTo = '';

export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    if (held === 0) {
      restoreTo = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    held += 1;
    return () => {
      held -= 1;
      if (held === 0) document.body.style.overflow = restoreTo;
    };
  }, [active]);
}
